import musicianCreated from "../events/musician-created.js";
import musicianUpdated from "../events/musician-updated.js";
import musicianDeleted from "../events/musician-deleted.js";
import addMusicianClicked from "../events/add-musician-clicked.js";
import fileInputted from "../events/file-inputted.js";
import fileSent from "../events/file-sent.js";
import progressReceived from "../events/progress-received.js";
import musiciansReordered from "../events/musicians-reordered.js";
import reorderBtnClicked from "../events/reorder-btn-clicked.js";
function makeEventRouter() {
    const router = {
        'add-musician-clicked': addMusicianClicked,
        'reorder-btn-clicked': reorderBtnClicked
    };
    const routerWithData = {};
    const formRouterWithData = {
        'form-created': musicianCreated,
        'form-updated': musicianUpdated,
        'form-deleted': musicianDeleted,
        'entities-reordered': musiciansReordered
    };
    const fileRouterWithData = {
        'file-inputted': fileInputted,
        'file-sent': fileSent,
        'progress-received': progressReceived
    };
    return Object.freeze({
        get,
        getWithData,
        getFormActionWithData,
        getFileActionWithData
    });
    function get(action) {
        return router[action];
    }
    function getWithData(action) {
        return routerWithData[action];
    }
    function getFormActionWithData(action) {
        return formRouterWithData[action];
    }
    function getFileActionWithData(action) {
        return fileRouterWithData[action];
    }
}
;
const APP_VIEWS = makeEventRouter();
export default APP_VIEWS;
